import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, first, map, Observable, tap } from 'rxjs';
import { MASTER_WHITELABEL_ID } from '../constants/whitelabel.constants';
import { MeProfile } from '../services/profile/me-profile.model';
import { HomeState } from '@/modules/home/core/state/home.state';
import { FetchMeUser } from '@/modules/home/core/state/home.actions';

@Injectable({
  providedIn: 'root',
})
export class ServicePackagesGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return this.store.select(HomeState.getMe).pipe(
      tap((me) => {
        if (!me) {
          this.store.dispatch(new FetchMeUser());
        }
      }),
      filter((me): me is MeProfile => !!me),
      first(),
      map((me) => {
        const hasAccess = this.checkAccess(me);

        if (!hasAccess) {
          this.router.navigate(['/minhas-cameras']);
          return false;
        }

        return true;
      }),
    );
  }

  private checkAccess(me: MeProfile): boolean {
    const userPermissions = me?.permissions?.map((p) => p.permission_key) || [];
    const hasPermission =
      userPermissions.includes('can_see_service_packages_tab') ||
      !!me?.masterAdmin;
    const isMasterWhitelabel = me?.whitelabel?.id === MASTER_WHITELABEL_ID;

    return hasPermission && isMasterWhitelabel;
  }
}
